<template>
  <header
    class="fixed w-full top-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-100"
  >
    <div class="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
      <a href="#" class="flex items-center gap-3">
        <!-- Icon -->
        <div
          class="w-9 h-9 bg-red-700 rounded-lg flex items-center justify-center text-white shadow-sm"
        >
          <svg
            class="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
            ></path>
          </svg>
        </div>

        <!-- Text -->
        <div class="flex items-baseline gap-1.5">
          <span class="font-rounded font-bold text-2xl text-primary"
            >Happy<span class="text-yellow-500">Buy</span></span
          >
          <span class="w-1.5 h-1.5 rounded-full bg-red-700 mb-1"></span>
          <span class="font-tc text-sm font-medium text-gray-500"
            >電商系統</span
          >
        </div>
      </a>
      <nav
        class="hidden md:flex gap-8 items-center text-sm font-medium text-gray-600"
      >
        <a href="#features" class="hover:text-brand transition-colors"
          >核心功能</a
        >
        <a href="#demo" class="hover:text-brand transition-colors">介面展示</a>
        <a href="#marketing" class="hover:text-brand transition-colors"
          >行銷模組</a
        >
        <button
          class="bg-primary text-white px-6 py-2.5 rounded-full text-sm font-bold hover:bg-gray-800 transition-transform active:scale-95 shadow-lg"
        >
          免費諮詢
        </button>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: "MainHeader",
};
</script>
